<script lang="ts">
	import chevronUpIcon from '$lib/assets/chevron-up.svg';
</script>

<img src={chevronUpIcon} alt="Chevron up" />
